export interface Privacy { gdpr?:0|1; consent?:string; usPrivacy?:string; gpp?:string; gppSid?:number[] }
export interface SupplyChain { ver:'1.0'; complete:0|1; nodes:Array<{asi:string;sid:string;hp:0|1;rid?:string;name?:string;domain?:string}> }
export interface PublisherSignals { privacy?:Privacy; schain?:SupplyChain; contentLanguage?:string }
declare global { interface Window { FelixAdsSignals?: (unitId:string)=>Promise<PublisherSignals|null>|PublisherSignals|null } }
export async function publisherSignals(unitId:string):Promise<PublisherSignals|null> {
  // null explicitly denies the request. Missing provider never invents consent.
  if(!window.FelixAdsSignals)return {};
  let timer:ReturnType<typeof setTimeout>|undefined;
  try{return await Promise.race([Promise.resolve(window.FelixAdsSignals(unitId)),new Promise<never>((_,reject)=>{timer=setTimeout(()=>reject(new Error('Publisher signal timeout')),3000);})]);}finally{clearTimeout(timer);}
}
export function compactSchain(chain:SupplyChain):string {
  if(chain.ver!=='1.0'||![0,1].includes(chain.complete)||!Array.isArray(chain.nodes)||chain.nodes.length===0)throw new Error('Invalid schain');
  const values=chain.nodes.map(node=>{
    if(!node.asi||!node.sid||![0,1].includes(node.hp))throw new Error('Invalid schain node');
    return [node.asi,node.sid,node.hp,node.rid??'',node.name??'',node.domain??''].map(String).map(encodeURIComponent).join(',');
  });
  return `${chain.ver},${chain.complete}!${values.join('!')}`;
}
